import { render } from "./QRcodes.vue?vue&type=template&id=2292f3f4&scoped=true"
import script from "./QRcodes.vue?vue&type=script&lang=js"
export * from "./QRcodes.vue?vue&type=script&lang=js"

import "./QRcodes.vue?vue&type=style&index=0&id=2292f3f4&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2292f3f4"]])

export default __exports__